import { Icon } from "@iconify/react/dist/iconify.js";
import { TextInput } from "@mantine/core";
import { useLocation } from "@remix-run/react";
import React from "react";

import { Can } from "~/lib/ability";

import { InputSearchParams } from "./input-types";

const InputSearch: React.FC<InputSearchParams> = ({
  placeholder = "Cari Data",
  value,
  onChange,
  onKeyUp,
  className = "",
}) => {
  const { pathname } = useLocation();
  return (
    <Can I="canRead" on={pathname}>
      <TextInput
        leftSection={
          <Icon icon="tabler:search" className="w-4 h-4 font-semibold" />
        }
        size="sm"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyUp={onKeyUp}
        className={className}
      />
    </Can>
  );
};

export default InputSearch;
